export function shouldSimulateLoad(count: number, skipLoad?: boolean): boolean {
  if (skipLoad) return false;
  return count > 0;
}
